// extracted by mini-css-extract-plugin
module.exports = {"label":"DateList_label__24tx3","first":"DateList_first__2Ia-p"};